// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fake-left-menu{position:fixed;left:0;top:156px;background-color:#fff;width:299px;height:100%;z-index:10}", ""]);
// Exports
module.exports = exports;
